import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { COLORS, FONTS } from '../../constants';
import EditJobModalForm from './EditJobModalForm';

const styles = {
  root: {
    fontFamily: FONTS.PRIMARY,
    color: COLORS.GREY_DARK,
    paddingLeft: 20,
    paddingRight: 20,
  },
  formTitle: {
    paddingLeft: '20px',
  },
  formSubtitle: {
    paddingLeft: '20px',
  },
  topCloseButton: {
    zIndex: 10,
    top: 0,
    right: 0,
    color: COLORS.GREEN,
    position: 'absolute',
  },
};

const EditJobModalContainer = props => {
  const {
    job,
    handleLeadJobUpdate,
    isOpen,
    setIsOpen,
    handleLocationChange,
    dispatchApiCallFailed,
    dispatchApiCallSuccess,
  } = props;

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <Dialog maxWidth="md" fullWidth open={isOpen} onEscapeKeyDown={onClose}>
      <div style={styles.root}>
        <IconButton
          aria-label="Close"
          style={styles.topCloseButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
        <h3 style={styles.formTitle}>Edit Job</h3>
        <h5 style={styles.formSubtitle}>Enter customer details below</h5>
        <EditJobModalForm
          job={job}
          handleLeadJobUpdate={handleLeadJobUpdate}
          setIsOpen={setIsOpen}
          handleLocationChange={handleLocationChange}
          dispatchApiCallFailed={dispatchApiCallFailed}
          dispatchApiCallSuccess={dispatchApiCallSuccess}
        />
      </div>
    </Dialog>
  );
};

EditJobModalContainer.propTypes = {
  job: PropTypes.object,
  handleLeadJobUpdate: PropTypes.func,
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
  handleLocationChange: PropTypes.func,
  dispatchApiCallFailed: PropTypes.func,
  dispatchApiCallSuccess: PropTypes.func,
};

export default EditJobModalContainer;
